import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";

// import usePrivateLink from "../config/usePrivateLink";
// import { useNavigate, useLocation } from "react-router-dom";

// const BusHeader = ({ data }) => {
//     const navigate = useNavigate();
//     const location = useLocation();

//  const tabs = [
//     {
//         id: "admitStudent",
//         title: "Admit Student",
//         icon: "fa-solid fa-user-plus",
//         path: "/admit/student/bus"
//     },

//     {
//         id: "busStudentList",
//         title: "Bus Student List",
//         icon: "fa-solid fa-list-ul",
//         path: "/bus/students"
//     },

//     {
//         id: "buses",
//         title: "Buses",
//         icon: "fa-solid fa-bus",
//         path: "/bus"
//     },

//     {
//         id: "busRoutes",
//         title: "Buses Routes",
//         icon: "fa-solid fa-route",
//         path: "/bus/routes"
//     }
// ];

//     return (
//         <div className="">

//             {/* ✅ Sidebar Menu */}
//             <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
//                 <h5 className="text-primary text-center p-2">{data}</h5>
//                 {tabs.map((tab) => {
//                     const isActive = location.pathname === tab.path;

//                     return (
//                         <button
//                             key={tab.id}
//                             className={`list-group-item list-group-item-action d-flex align-items-center ${isActive ? "active" : ""
//                                 }`}
//                             onClick={() => navigate(tab.path)}
//                         >
//                             <i className={`${tab.icon} me-2`} />
//                             {tab.title}
//                         </button>
//                     );
//                 })}
//             </div>

//             {/* ✅ Page Content */}
//         </div>
//     );
// };

// export default BusHeader;


const BusHeader = ({ data }) => {
  const hasAccess = usePrivateLink();
  const navigate = useNavigate();
  const location = useLocation();
const tabs = [
    {
      id: "admitStudent",
      title: "Admit Student",
      icon: "ri-user-add-line",
      path: "/admit/student/bus",
    },

    {
      id: "busStudentList",
      title: "Bus Student List",
      icon: "ri-list-check-2",
      path: "/bus/students",
    },

    {
      id: "buses",
      title: "Buses",
      icon: "ri-bus-line",
      path: "/bus",
    },

    {
      id: "busRoutes",
      title: "Buses Routes",
      icon: "ri-map-pin-line",
      path: "/bus/routes",
    },
    {
      id: "busAttendance",
      title: "Bus Attendance",
      icon: "ri-calendar-line",
      path: "/bus/student/attendance/list",
    },
  ];


  const filteredTabs = tabs.filter((tab) => hasAccess(tab.path));

  return (
    <div className="">
      {/* ✅ Sidebar Menu */}
      <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
        <h5 className="text-primary text-center p-2">{data}</h5>
        {filteredTabs.length === 0 && (
          <div className="text-center text-danger">
            You don't have permission to access any tabs.
          </div>
        )}
        {filteredTabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const permission = hasAccess(tab.path);

          return (
            <button
              key={tab.id}
              className={`list-group-item list-group-item-action d-flex align-items-center ${
                isActive ? "bg-label-primary" : ""
              } ${!permission ? "disabled-tab" : ""}`}
              onClick={() => permission && navigate(tab.path)}
              style={{
                cursor: permission ? "pointer" : "not-allowed",
                color: !permission ? "red" : "inherit",
                backgroundColor: !permission ? "#f8d7da" : "inherit",
              }}
              disabled={!permission}
            >
              <i className={`${tab.icon} me-2`} />
              {tab.title}
            </button>
          );
        })}
      </div>

      {/* ✅ Page Content */}
    </div>
  );
};

export default BusHeader;
